import React from 'react';
import { useNavigate } from "react-router-dom";
import { UserContext } from "../../contexts/UserContext";
import { Grid, Paper, Typography, Tabs, Tab } from "@mui/material";
import SnackBar from '../snackbar/SnackBar';
import EmailTest from './EmailTest';
// import ApprovalTest from './ApprovalTest';
import UserTable from './UserTable';
import ShowsTable from './ShowsTable';

export default function Admin() {
    const userCtx = React.useContext(UserContext);
    const navigate = useNavigate();
    const [tab, setTab] = React.useState(0);
    const [snackbarOpen, setSnackbarOpen] = React.useState(false);
    const [message, setMessage] = React.useState("");
    const [severity, setSeverity] = React.useState("info");

    React.useEffect(() => {
        if ( !userCtx.user ) navigate("/signin");
    }, [userCtx.user, navigate]);

    return (
        userCtx.user && !userCtx.user.admin ? navigate("/") :
        <>
        <Grid container sx={{pt: 3}} justifyContent="center">
            <Grid item xs={12} md={10}>
                <Paper square={false} variant="outlined" sx={{opacity: "0.98", mb: 3, p: {xs: 2, sm: 3}, color: "white"}}>
                    <Grid container>
                        <Grid item xs={12}>
                            <Typography gutterBottom variant="h6">
                                Admin Dashboard
                            </Typography>
                        </Grid>

                        <Grid item xs={12}>
                            <Tabs
                                value={tab}
                                onChange={(e, v) => setTab(v)}
                                sx={{
                                    borderBottom: 1,
                                    borderColor: 'divider',
                                    mb: 2,
                                    '& .MuiTab-root': { color: 'rgba(255,255,255,0.7)' },
                                    '& .Mui-selected': { color: 'white' },
                                    '& .MuiTabs-indicator': { backgroundColor: 'white' },
                                }}
                            >
                                <Tab label="Users" />
                                <Tab label="Shows" />
                            </Tabs>
                        </Grid>

                        {tab === 0 && (
                            <>
                                <EmailTest setMessage={setMessage} setSeverity={setSeverity} setSnackbarOpen={setSnackbarOpen}/>
                                {/* <ApprovalTest setMessage={setMessage} setSeverity={setSeverity} setSnackbarOpen={setSnackbarOpen}/> */}
                                <UserTable setMessage={setMessage} setSeverity={setSeverity} setSnackbarOpen={setSnackbarOpen} />
                            </>
                        )}

                        {tab === 1 && (
                            <ShowsTable setMessage={setMessage} setSeverity={setSeverity} setSnackbarOpen={setSnackbarOpen} />
                        )}
                    </Grid>
                </Paper>
            </Grid>
        </Grid>

        {/* SnackBar */}
        <SnackBar
            open={snackbarOpen}
            handleClose={(event, reason) => {
                if (reason === "clickaway") return;
                setSnackbarOpen(false);
            }}
            message={message}
            severity={severity}
        />
        </>
    )
}
